import { EntidadeBase } from 'hay-core-react';
import { ApiService } from 'hay-core-react';
class UsuarioSessaoModel extends EntidadeBase {
    constructor() {
        super('usuariosessao');
    }
    async desconectar(id) { return await ApiService.post('usuariosessao/desconectar', { id }); }
    async validarSessoesAtivas() { return await ApiService.post('usuariosessao/validarsessoesativas', {}); }
}
const instance = new UsuarioSessaoModel();
export default instance;
